import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Card,
    CardContent,
    Typography,
    Autocomplete,
    Chip,
} from "@mui/material";
import axiosInstance from "../../utilities/Axios";
import { enqueueSnackbar } from "notistack";
import { EDialogAction } from "../Enum/DialogActionEnum";
const JobExtraDialogBox = (props: {
    open: boolean;
    onClose: any;
    data: any;
    dialogAction: EDialogAction;
}) => {
    const { open, onClose, data, dialogAction } = props;
    const [jobTitle, setJobTitle] = useState("");
    const [extraTitle, setExtraTitle] = useState("");
    const [extra, setExtra] = useState<string[]>([]);

    const handleClose = (action: string = "closed") => {
        props.onClose(action);
    };

    useEffect(() => {
        if (data) {
            setJobTitle(data.title);
            setExtra(JSON.parse(data.extra || "[]"));
            setExtraTitle(data.extra_title || "");
        }
    }, [data, open]);

    const createJobExtra = async () => {
        try {
            const url = `${process.env.REACT_APP_API_ORIGIN}/v1/job-titles/extra`;
            const res = await axiosInstance.post(url, {
                job_title_id: data.id,
                extra,
                extra_title: extraTitle,
            });
            enqueueSnackbar("Extra Created Successfully!!!", { variant: "success" });
            onClose("created");
        } catch (err) {
            enqueueSnackbar("Extra Creation Unsuccessful!!!", { variant: "error" });
            console.error(err);
        }
    };

    return (
        <Dialog open={open} onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
                handleClose();
            }
        }} fullWidth maxWidth="sm">
            <DialogTitle>
                Job Title: <span style={{ fontWeight: "bold" }}>{jobTitle}</span>
            </DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} sx={{ mt: 2 }}>
                    <TextField
                        label="Title"
                        variant="outlined"
                        value={extraTitle}
                        onChange={(e) => setExtraTitle(e.target.value)}
                    />
                    <Autocomplete
                        multiple
                        freeSolo
                        options={[]}
                        value={extra}
                        onChange={(event, newValue) => setExtra(newValue)}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip color="primary" variant="outlined" label={option} {...getTagProps({ index })} key={option} />
                            ))
                        }
                        renderInput={(params) => <TextField {...params} label="Options" variant="outlined" placeholder="Select or add options"
                            onBlur={(e) => {
                                const value = e.target.value;
                                if (value) {
                                    setExtra((prev) => [...prev, value]);
                                }
                            }}
                        />}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose()} color="secondary" variant="contained">
                    Close
                </Button>
                <Button onClick={createJobExtra} color="primary" variant="contained">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default JobExtraDialogBox;